
export interface Report{
    timestamp: number,
    title: string,
    key?: string;

    isStock?: boolean,

    totalTrades: number,
    totalGain: number;
    largestGain: number;
    largestLoss: number;
    avgDuration: string;

    mostFrequentCoin?: string;
    performanceBTC?: number;
    performanceTotalMarketCap?: number;
    performanceBTCDominance?: number;

    bestPerformingSector?: string;
    worstPerformingSector?: string;

    markdown: string;
}

export function newReport(isStock: boolean): Report{
    let report: Report = {
        timestamp: null,
        title: null,
        key: null,

        isStock,

        totalTrades: 0,
        totalGain: 0,
        largestGain: 0,
        largestLoss: 0,
        avgDuration: null,

        markdown: null
    }

    if(isStock){
        report.bestPerformingSector = '';
        report.worstPerformingSector = '';
    }else{
        report.mostFrequentCoin = null;
        report.performanceBTC = 0;
        report.performanceTotalMarketCap = 0;
        report.performanceBTCDominance = 0;
    }
    return report;
}


// WEBPACK FOOTER //
// ./src/models/Report.ts